<script lang="ts">
  import { clipboardReadText } from '@/shared/ipc/app'
  import { onMount, tick } from 'svelte'
  import type { FocusEventHandler, HTMLInputTypeAttribute, KeyboardEventHandler } from 'svelte/elements'
  let {
    min = false,
    placeholder = '',
    disabled = false,
    readonly = false,
    value = $bindable(''),
    type = 'text',
    id,
    trim = false,
    stopcontenteventpropagation = true,
    autopaste = true,
    onbeforechange,
    onchange = () => {},
    onsubmit = () => {},
    onkeydown = () => {},
    onblur = () => {},
    autofocus = false,
    class: className,
    autoflex = false,
  }: {
    id?: string
    class?: string
    min?: boolean
    placeholder?: string
    disabled?: boolean
    readonly?: boolean
    value?: string
    type?: HTMLInputTypeAttribute
    trim?: boolean
    stopcontenteventpropagation?: boolean
    autopaste?: boolean
    autofocus?: boolean
    autoflex?: boolean
    onbeforechange?: (val: string) => string
    onchange?: (val: string) => void
    onsubmit?: (val: string) => void
    onkeydown?: KeyboardEventHandler<HTMLInputElement>
    onblur?: FocusEventHandler<HTMLInputElement>
  } = $props()

  let domInput: HTMLInputElement

  const handleInput = () => {
    if (readonly) {
      domInput.value = value
      return
    }
    let newValue = domInput.value
    if (trim) {
      newValue = newValue.trim()
      domInput.value = newValue
    }
    value = newValue
  }
  const handleKeyup = (event: KeyboardEvent) => {
    if (event.key != 'enter') return
    onsubmit(domInput.value.trim())
  }
  export const focus = () => {
    domInput.focus()
  }
  const handleContextMenu = async (event: Event) => {
    if (stopcontenteventpropagation) event.stopPropagation()
    if (!autopaste || readonly || disabled) return
    if (domInput.selectionStart === null) return
    let str = await clipboardReadText()
    str = str.trim()
    str = str.replace(/\t|\n|\r/g, ' ')
    str = str.replace(/\s+/g, ' ')
    const text = domInput.value
    // if (domInput.selectionStart == domInput.selectionEnd) {
    let newValue =
      text.substring(0, domInput.selectionStart) +
      str +
      text.substring(domInput.selectionEnd ?? domInput.selectionStart, text.length)
    if (onbeforechange) newValue = onbeforechange(newValue)
    domInput.value = newValue
    handleInput()
    onchange(domInput.value.trim())
    // } else {
    //   clipboardWriteText(text.substring(domInput.selectionStart, domInput.selectionEnd))
    // }
  }

  if (autofocus) {
    onMount(() => {
      void tick().then(() => {
        setTimeout(focus, 100)
      })
    })
  }
</script>

<input
  bind:this={domInput}
  class={['input', className, { min, autoflex }]}
  {id}
  {type}
  {placeholder}
  {value}
  {disabled}
  {onkeydown}
  {onblur}
  tabindex="0"
  oninput={handleInput}
  onchange={() => {
    if (readonly) return
    let newValue = domInput.value.trim()
    if (onbeforechange) newValue = onbeforechange(newValue)
    if (newValue !== domInput.value) {
      domInput.value = newValue
      handleInput()
    }
    onchange(newValue)
  }}
  onkeyup={handleKeyup}
  oncontextmenu={handleContextMenu}
/>

<style lang="less">
  .input {
    display: inline-block;
    padding: 5px 8px;
    font-size: 14px;
    color: var(--color-button-font);
    outline: none;
    background-color: var(--color-primary-background);
    border: none;
    border-radius: @form-radius;
    transition: background-color 0.2s ease;

    &::-webkit-outer-spin-button,
    &::-webkit-inner-spin-button {
      margin: 0;
      appearance: none;
    }

    &[disabled] {
      opacity: 0.4;
    }

    &:hover,
    &:focus {
      background-color: var(--color-primary-background-hover) !important;
    }
    &:active {
      background-color: var(--color-primary-background-active) !important;
    }
  }

  .min {
    padding: 3px 8px;
    font-size: 12px;
  }

  .autoflex {
    flex: auto;
  }
</style>
